<div class="hero-image">
  <app-services-main></app-services-main>
</div>
